import { HuitabConstantes } from '../../shared/enums/huitab-constantes.enum';
import { StoreKeys } from '../../shared/enums/store-keys.enum';
import { ComponentHelper } from '../../shared/services/component-helper';
import { huitabSettings } from '../../shared/services/settings-loader';
import { StoreManager } from '../../shared/services/store-manager';
import { TagCommanderManager } from '../../shared/services/tag-commander-manager';
import { ModalSupprimerInterlocuteur } from './modals/supprimer-interlocuteur/modal-supprimer-interlocuteur';

require('../../core/require');
require('../../assets/scss/b2b-style.scss');
require('./page.scss');

export const modalSupprimerInterlocuteur = new ModalSupprimerInterlocuteur();

let premiereRecherche = true;

function _displayOnSelectedSirenChanged(siren) {
  if (StoreManager.selectedSiren === HuitabConstantes.SIREN_ALL) {
    afficherSelectionCollectivite();
    premiereRecherche = false;
  } else {
    afficherPageVosInterlocuteurs();
    if (premiereRecherche) {
      premiereRecherche = false;
      return;
    }
    const lncWebRechercheInterlocuteurs = document.querySelector(
      '#bloc-critere-recherche lnc-web-recherche-interlocuteurs',
    );
    // Reset du champ des numéros de PRMs + envoi de la recherche
    if (lncWebRechercheInterlocuteurs) {
      const lncWebRechercheInterlocuteursResetButton = lncWebRechercheInterlocuteurs.querySelector('lnc-button');
      if (lncWebRechercheInterlocuteursResetButton) lncWebRechercheInterlocuteursResetButton.click();
      const searchClickEvent = new CustomEvent('searchClick', { detail: { prm: [], siren: '', siret: [] } });
      lncWebRechercheInterlocuteurs.dispatchEvent(searchClickEvent);
    }
  }
}

function afficherSelectionCollectivite() {
  afficherPage(['veuillez-selectionner-collectivite']);
}

function afficherPageVosInterlocuteurs() {
  const perimetreCourant = getPerimetreCourant();
  const fonctionsSurLePerimetre = perimetreCourant.fonctionnalites;
  if (fonctionsSurLePerimetre.includes('INFO_COUPURES')) {
    afficherPage(['bloc-vos-interlocuteurs']);
  } else {
    afficherFonctionnaliteInaccessible();
  }
}

if (!huitabSettings.feature_flipping.interlocuteurs_unitaire_et_masse) {
  const menuInterlocuteurs = document.getElementById('flipping_interlocuteurs_coupures');
  const menuInterlocuteursTablette = document.getElementById('flipping_interlocuteurs_coupures_tablette');
  if (menuInterlocuteurs !== null) menuInterlocuteurs.remove();
  if (menuInterlocuteursTablette !== null) menuInterlocuteursTablette.remove();
} else {
  _initialiserRechercheInterlocuteurs();
  StoreManager.subscribe(StoreKeys.SELECTED_SIREN, _displayOnSelectedSirenChanged.bind(this));
}

/* *************************************************************************************************** */
/* ******************************** Affichage du bloc de recherche *********************************** */
/* *************************************************************************************************** */
function _initialiserRechercheInterlocuteurs() {
  // Ajout du bloc critère de recherche en masquant les champs Siret et Siren
  const lncWebRechercheInterlocuteurs = Object.assign(document.createElement('lnc-web-recherche-interlocuteurs'), {
    afficherSiret: false,
    afficherSiren: false,
  });

  // gestion du clic sur le bouton "Rechercher" du formulaire
  lncWebRechercheInterlocuteurs.addEventListener('searchClick', (event) => {
    const rechercheInterlocuteursModel = event.detail;
    // on ajoute le siren selectionné côté portail aux critères de recherche
    rechercheInterlocuteursModel.siren = StoreManager.selectedSiren;
    // on récupère le nom de la collectivité correspondant au siren sélectionné
    const perimetreCourant = getPerimetreCourant();
    if (!perimetreCourant) return;
    rechercheInterlocuteursModel.libelleSiren = perimetreCourant.localite;
    // on envoie les critères de recherche et le nom de la collectivité pour qu'ils soient lus par la microapp
    ComponentHelper.pymSendMessage('rechercherInterlocuteurs', JSON.stringify(rechercheInterlocuteursModel));
    // on envoie le tag de click
    TagCommanderManager.tagClick({
      chapitre_1: 'mon_reseau_electrique',
      chapitre_2: 'interlocuteurs_prevenance',
      page: 'rechercher',
      type: 'action',
    });
  });

  document.getElementById('bloc-critere-recherche')?.appendChild(lncWebRechercheInterlocuteurs);
}

function getPerimetreCourant() {
  return StoreManager.perimetre.find((el) => el.siren === StoreManager.selectedSiren);
}

/* *************************************************************************************************** */
/* ************************************** Affichage pages ******************************************** */
/* *************************************************************************************************** */
/**
 * Cache toutes les pages et affiche seulement celle demandée
 * @param ids {Array} Liste d'ids a afficher (optionnel)
 */
function afficherPage(ids = []) {
  let array = [
    '#fonctionnalite-inaccessible-mono',
    '#fonctionnalite-inaccessible-multi',
    '#bloc-vos-interlocuteurs',
    '#veuillez-selectionner-collectivite',
  ];

  document.querySelectorAll(array.toString()).forEach((bloc) => (bloc.hidden = true));

  if (ids.length > 0) {
      ids.forEach(id => {
          let blocAfficher = document.getElementById(id);
          if (blocAfficher) blocAfficher.hidden = false;
          let titre = document.getElementById("titre-interlocuteurs");
          if (titre) {
            const hideTitles = ids.includes("veuillez-selectionner-collectivite");
            titre.hidden = hideTitles;
          }
      });
  }
}

function afficherFonctionnaliteInaccessible() {
  if (StoreManager.isMultiCollectivites) {
    afficherPage(['fonctionnalite-inaccessible-multi']);
  } else {
    afficherPage(['fonctionnalite-inaccessible-mono']);
  }
  TagCommanderManager.tagPage({
    chapitre_1: 'mon_reseau_electrique',
    chapitre_2: 'interlocuteurs_prevenance',
    page: 'non_habilite_vous_navez_pas_acces_a_cette_fonctionnalite',
  });
}
